var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Effect, Actions } from '@ngrx/effects';
import * as freelancerAction from '../actions/freelancer.action';
import { mergeMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { FreelancerService } from '../../freelancer.service';
var FreelancerEffect = /** @class */ (function () {
    function FreelancerEffect(actions, freelancerService, store) {
        var _this = this;
        this.actions = actions;
        this.freelancerService = freelancerService;
        this.store = store;
        this.getAssignedFreelancers = this.actions.ofType(freelancerAction.GET_ASSIGNED_FREELANCERS)
            .map(function (action) { return action.payload; })
            .pipe(mergeMap(function (body) {
            return _this.freelancerService.getAssignedFreelancers(body)
                .map(function (res) { return new freelancerAction.GetAssignedFreelancersSuccess(res); })
                .catch(function (error) { return of(new freelancerAction.GetAssignedFreelancersError(error)); });
        }));
        this.getFreelancer = this.actions.ofType(freelancerAction.GET_FREELANCER)
            .map(function (action) { return action.payload; })
            .pipe(mergeMap(function (body) {
            return _this.freelancerService.getFreelancers(body)
                .map(function (res) { return new freelancerAction.GetFreelancerSuccess(res); })
                .catch(function (error) { return of(new freelancerAction.GetFreelancerError(error)); });
        }));
        this.getApprovedFreelancers = this.actions.ofType(freelancerAction.GET_APPROVED_FREELANCERS)
            .map(function (action) { return action.payload; })
            .pipe(mergeMap(function (body) {
            return _this.freelancerService.getApprovedFreelancers(body)
                .map(function (res) { return new freelancerAction.GetApprovedFreelancersSuccess(res); })
                .catch(function (error) { return of(new freelancerAction.GetAssignedFreelancersError(error)); });
        }));
        this.updateApprovedFreelancer = this.actions.ofType(freelancerAction.UPDATE_ASSIGNED_FREELANCERS)
            .map(function (action) { return action.payload; })
            .pipe(mergeMap(function (body) {
            return _this.freelancerService.updateApprovedFreelancers(body)
                .map(function (res) { return new freelancerAction.UpdateAssignedFreelancersSuccess(res); })
                .catch(function (error) { return of(new freelancerAction.UpdateAssignedFreelancersError(error)); });
        }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], FreelancerEffect.prototype, "getAssignedFreelancers", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], FreelancerEffect.prototype, "getFreelancer", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], FreelancerEffect.prototype, "getApprovedFreelancers", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], FreelancerEffect.prototype, "updateApprovedFreelancer", void 0);
    return FreelancerEffect;
}());
export { FreelancerEffect };



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/freelancers/store/effects/freelancer.effect.ts.pre-build-optimizer.js